<template>
	<div
		class="g-header-info-card-preview"
		:class="{
			'g-header-info-card-preview--h5': h5,
			'g-header-info-card-preview--compact': compact,
			'g-header-info-card-preview--panel-list': panel === 'list',
			'g-header-info-card-preview--panel-edit': panel === 'edit',
		}"
		@click="onClick"
	>
		<div class="g-header-info-card-preview__cover" :style="coverStyle">
			<img
				v-if="coverUrl"
				:src="coverUrl"
				class="g-header-info-card-preview__cover-img"
				alt=""
			/>
			<i v-else class="mbm-iconfont mbm-tupian g-header-info-card-preview__cover-empty"></i>
		</div>
		<div class="g-header-info-card-preview__text">
			<div
				v-if="normalizedData.title"
				class="g-header-info-card-preview__title"
				:style="{ color: normalizedData.titleColor }"
			>{{ normalizedData.title }}</div>
			<div
				v-if="normalizedData.subtitle"
				class="g-header-info-card-preview__subtitle"
				:style="{ color: normalizedData.subtitleColor }"
			>{{ normalizedData.subtitle }}</div>
		</div>
	</div>
</template>

<script>
	import { navigateJumpLink } from '../utils/jumpLink.js';
	import {
		getHeaderInfoCardImageUrl,
		normalizeHeaderInfoCardData,
	} from '../utils/headerInfoCard.js';

	export default {
		name: 'GHeaderInfoCardPreview',
		props: {
			data: {
				type: Object,
				default: () => ({}),
			},
			h5: {
				type: Boolean,
				default: false,
			},
			compact: {
				type: Boolean,
				default: false,
			},
			interactive: {
				type: Boolean,
				default: true,
			},
			panel: {
				type: String,
				default: 'edit',
			},
		},
		computed: {
			normalizedData() {
				return normalizeHeaderInfoCardData(this.data);
			},
			coverUrl() {
				return getHeaderInfoCardImageUrl(this.normalizedData.image);
			},
			coverStyle() {
				return {
					borderColor: this.normalizedData.borderColor,
					borderWidth: `${this.normalizedData.borderWidth}px`,
					borderRadius: `${this.normalizedData.imageRadius}px`,
				};
			},
		},
		methods: {
			onClick() {
				if (!this.h5 || !this.interactive || !this.normalizedData.jumpLink?.type) return;
				navigateJumpLink(this.normalizedData.jumpLink, {
					apiRequest: this.$apiRequest,
				});
			},
		},
	};
</script>

<style scoped lang="less">
	.g-header-info-card-preview {
		display: flex;
		align-items: center;
		gap: 16px;
		padding: 16px 0;
		box-sizing: border-box;
		background-color: #fff;
	}

	.g-header-info-card-preview__cover {
		flex-shrink: 0;
		width: 160px;
		height: 160px;
		border-style: solid;
		border-color: #5eb3ff;
		border-width: 4px;
		border-radius: 8px;
		box-sizing: border-box;
		overflow: hidden;
		background: #fafafa;
	}

	.g-header-info-card-preview__cover-img {
		display: block;
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.g-header-info-card-preview__cover-empty {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
		font-size: 32px;
		color: #bfbfbf;
	}

	.g-header-info-card-preview__text {
		min-width: 0;
		flex: 1;
	}

	.g-header-info-card-preview__title {
		font-size: 26px;
		font-weight: 700;
		line-height: 1.4;
		word-break: break-word;
	}

	.g-header-info-card-preview__subtitle {
		margin-top: 12px;
		font-size: 18px;
		font-weight: 400;
		line-height: 1.4;
		word-break: break-word;
	}

	.g-header-info-card-preview--h5 {
		gap: 0.32rem;
		padding: 0.4rem 0 0 !important;

		.g-header-info-card-preview__cover {
			width: 1.6rem;
			height: 1.6rem;
			border-width: 0.08rem;
			border-radius: 0.16rem;
		}

		.g-header-info-card-preview__title {
			font-size: 0.36rem !important;
		}

		.g-header-info-card-preview__subtitle {
			margin-top: 0.08rem;
			font-size: 0.30rem !important;
		}

		.g-header-info-card-preview__cover-empty {
			font-size: 0.56rem;
		}
	}

	.g-header-info-card-preview--compact {
		gap: 10px;
		padding: 20px 10px;

		.g-header-info-card-preview__cover {
			width: 80px;
			height: 80px;
			border-width: 4px;
			border-radius: 8px;
		}

		.g-header-info-card-preview__title {
			font-size: 16px;
		}

		.g-header-info-card-preview__subtitle {
			margin-top: 8px;
			font-size: 14px;
		}

		.g-header-info-card-preview__cover-empty {
			font-size: 22px;
		}
	}

	.g-header-info-card-preview--panel-list {
		padding: 10px;

		.g-header-info-card-preview__cover {
			width: 80px;
			height: 80px;
			border-width: 4px;
			border-radius: 6px;
		}

		.g-header-info-card-preview__title {
			font-size: 18px;
		}

		.g-header-info-card-preview__subtitle {
			margin-top: 4px;
			font-size: 15px;
		}

		.g-header-info-card-preview__cover-empty {
			font-size: 18px;
		}
	}

	.g-header-info-card-preview--panel-edit {

		.g-header-info-card-preview__cover {
			width: 85px;
			height: 85px;
			border-width: 4px;
			border-radius: 7px;
		}

		.g-header-info-card-preview__title {
			font-size: 20px;
		}

		.g-header-info-card-preview__subtitle {
			margin-top: 5px;
			font-size: 16px;
		}

		.g-header-info-card-preview__cover-empty {
			font-size: 32px;
		}
	}

	
</style>
